module.exports = __webpack_public_path__ + "img/banner3.c7a5fa14.jpg";